/**
 * O aviso de que a mensagem pronta tem um telefone ou um e-mail.
 *
 * Não é recusa: o número pode ser o da loja. É a pergunta que faz a pessoa
 * olhar antes de salvar, porque a lista é lida pela organização inteira e vira
 * atalho para outros clientes. Quem monta o formulário trava o "salvar" até a
 * confirmação.
 */

import type { ReactNode } from 'react';
import { Faixa } from '@/shared/ui/estados/faixa';

export function AvisoDeContato({ aoConfirmar }: { aoConfirmar: () => void }): ReactNode {
  return (
    <Faixa tom="atencao" acao={{ rotulo: 'É da loja, pode salvar', aoClicar: aoConfirmar }}>
      Tem telefone ou e-mail aqui. Se for de um cliente, tire antes de salvar: a organização inteira
      lê esta lista.
    </Faixa>
  );
}
